module.exports = __webpack_public_path__ + "img/43_83.bf88361a.png";